import '@babel/polyfill';
import 'whatwg-fetch';

import Contents from './contentSource';
import { getHostBaseUrl, resolvePrefixUrlConditionally } from './common/utilities';

export const ContentSource = new Contents();
// export const ContentFeature = new Features();

export { getHostBaseUrl, resolvePrefixUrlConditionally };

if (typeof window !== 'undefined') {
    window.getHostBaseUrl = window.getHostBaseUrl || getHostBaseUrl;
    window.resolvePrefixUrlConditionally = window.resolvePrefixUrlConditionally || resolvePrefixUrlConditionally;
}

